import _ from 'lodash';
import { useEffect, useState } from 'react';
export function useAccordionFunctions(_a) {
    var _b = _a === void 0 ? {} : _a, isExpanded = _b.isExpanded, _c = _b.isDefaultExpanded, isDefaultExpanded = _c === void 0 ? false : _c, onExpandedChange = _b.onExpandedChange;
    var _d = useState(isDefaultExpanded), shouldRenderContent = _d[0], setShouldRenderContent = _d[1];
    var _e = useState(isDefaultExpanded), isOpening = _e[0], setIsOpening = _e[1];
    var _f = useState(isDefaultExpanded), isOpen = _f[0], setIsOpen = _f[1];
    var _g = useState(false), isClosing = _g[0], setIsClosing = _g[1];
    var open = function () {
        if (isOpening || isOpen) {
            return;
        }
        // Start opening animation
        setShouldRenderContent(true);
        setTimeout(function () {
            setIsOpening(true);
            setTimeout(function () {
                setIsOpen(true);
            }, 60);
        }, 100);
    };
    var close = function () {
        if (isClosing || !isOpen) {
            return;
        }
        // Start closing animation
        setIsClosing(true);
        setIsOpen(false);
        setTimeout(function () {
            setShouldRenderContent(false);
            setIsOpening(false);
            setTimeout(function () {
                setIsClosing(false);
            }, 600);
        }, 600);
    };
    var toggle = function () {
        if (isOpen) {
            close();
        }
        else {
            open();
        }
    };
    useEffect(function () {
        // Notify consumers of the expanded state change
        _.attempt(onExpandedChange, isOpen);
    }, [isOpen]);
    useEffect(function () {
        // If the `isExpanded` prop is provided (ie. the accordion is controlled), update the state accordingly
        if (isExpanded !== undefined) {
            if (isExpanded) {
                open();
            }
            else {
                close();
            }
        }
    }, [isExpanded]);
    return { shouldRenderContent: shouldRenderContent, isOpening: isOpening, isOpen: isOpen, isClosing: isClosing, open: open, close: close, toggle: toggle };
}
